import { HeaderLayoutProps } from '@components_v2/UI/atoms/header/Header';

const cashout = { id: 'cash_out_lead_form', name: 'Get Cash from Your Equity' };
const refi = { id: 're_fi_lead_form', name: 'Refinance Your Mortgage' };
const purchase = { id: 'purchase_lead_form', name: 'Purchase a New Home' };
const home = { id: 'home', name: 'Home' };
const digiapp = { id: 'my_application', name: 'My Application' };
const newloan = { id: 'new_loan', name: 'Loan Progress' };
const disasterAssist = { id: 'disaster_assist', name: 'Natural Disaster Assistance' };
const disasterDeclaration = { id: 'disaster_declaration', name: 'Natural Disaster Declaration' };
const escrowAnalysis = { id: 'escrow_analysis', name: 'Escrow Analysis' };
const messageCenter = { id: 'message_center', name: 'Messages' };
const error = { id: 'error', name: 'Error' };

export const CashOutNavigationProps: HeaderLayoutProps = {
    title: 'Get Cash from Your Equity',
    BreadCrumbs: [home, cashout],
    showDropDownOptions: false
};

export const DigiAppNavigationProps = {
    title: 'My Application',
    BreadCrumbs: [home, digiapp],
    showDropDownOptions: false,
    useExitIntent: true
};

export const ReFiNavigationProps = {
    title: 'Refinance Your Mortgage',
    BreadCrumbs: [home, refi],
    showDropDownOptions: false
};

export const PurchaseNavigationProps = {
    title: 'Purchase a New Home',
    BreadCrumbs: [home, purchase],
    showDropDownOptions: false
};

export const NewLoanInProgressNavigationProps = {
    title: 'Loan Progress',
    BreadCrumbs: [home, newloan],
    optionalMenu: true
};

export const EscrowNavigationProps = {
    title: 'Escrow Analysis',
    BreadCrumbs: [home, escrowAnalysis],
    showDropDownOptions: false
};

export const ImpactedPropNavigationProps = {
    title: 'Natural Disaster Declaration',
    BreadCrumbs: [home, disasterDeclaration],
    showDropDownOptions: false
};

export const DisasterAssistNavigationProps = {
    title: 'Natural Disaster Assistance',
    BreadCrumbs: [home, disasterAssist],
    showDropDownOptions: false
};

export const MessageCenterNavigationProps: HeaderLayoutProps = {
    title: 'Messages',
    BreadCrumbs: [home, messageCenter],
    showDropDownOptions: false
};

export const ErrorProps = {
    title: 'Error',
    BreadCrumbs: [home, error],
    showDropDownOptions: false
};
